import { EventBus } from '@pp/toolkit';

import { StreamQuality } from '../../store/slices/settings/types';

export class VideoServicePlayback extends EventBus<{
  playing: (playing: boolean) => void;
  enabled: (enabled: boolean) => void;
  volume: (volume: number) => void;
  channel: (channel: StreamQuality) => void;
}> {
  private _playing: boolean = false;
  private _enabled: boolean = false;
  private _volume: number = 0;
  private _channel: StreamQuality = StreamQuality.Auto;

  setPlaying(value: boolean): void {
    if (value === this._playing) return;
    this._playing = value;
    this.dispatchEvent('playing', value);
  }
  get playing(): boolean {
    return this._playing;
  }

  setEnabled(value: boolean): void {
    if (value === this._enabled) return;
    this._enabled = value;
    this.dispatchEvent('enabled', value);
  }
  get enabled(): boolean {
    return this._enabled;
  }

  setVolume(value: number): void {
    if (value === this._volume) return;
    this._volume = value;
    this.dispatchEvent('volume', value);
  }
  get volume(): number {
    return this._volume;
  }

  setChannel(value: StreamQuality): void {
    if (value === this._channel) return;
    this._channel = value;
    this.dispatchEvent('channel', value);
  }
  get channel(): StreamQuality {
    return this._channel;
  }

  reset(): void {
    super.clear();
    this._playing = false;
    this._enabled = false;
    this._volume = 0;
    this._channel = StreamQuality.Auto;
  }
}
